
<div class="animated fadeIn p-4">
    <div class="d-flex align-items-center">
        <h1>{{ 'DASHBOARD.LOGOUT' | translate }}</h1>
    </div>
    <p-toast></p-toast>
    <p-messages [(value)]="msgs"></p-messages>
</div>
